import script from "./lazy-component.vue?vue&type=script&lang=ts&setup=true"
export * from "./lazy-component.vue?vue&type=script&lang=ts&setup=true"

import "./lazy-component.vue?vue&type=style&index=0&id=279bb055&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279bb055"]])

export default __exports__